import { render, staticRenderFns } from "./reasons-cancellation.component.vue?vue&type=template&id=1d76ad71&scoped=true&"
import script from "./reasons-cancellation.component.vue?vue&type=script&lang=ts&"
export * from "./reasons-cancellation.component.vue?vue&type=script&lang=ts&"
import style0 from "./reasons-cancellation.component.vue?vue&type=style&index=0&id=1d76ad71&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d76ad71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VSwitch})
